import React, { useContext, useEffect, useState } from "react";

// Polyfills for older browsers
import "core-js/stable";
import "regenerator-runtime/runtime"; // Polyfills async/await, generators
import "whatwg-fetch"; // Polyfill fetch on older browsers

import { ProductsContext } from "../../context/products.context";

import ProductCard1 from "./ProductCard1";

import LoadingSpinner from "../../components/loader/Myloader";

export const ProductsRange = () => {
  const { products, getMyProducts, getMyProductsByCustomerGroup } =
    useContext(ProductsContext);

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  //get all products check if products have discount

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        getMyProductsByCustomerGroup();
      } catch (err) {
        setError(err.message);
      } finally {
        // products.map((product) => {
        //   console.log("products to be displayed");
        //   console.log(product.id);
        // });
        setLoading(false);
      }
    };

    // Call the async function
    fetchData();
  }, []); // Dependency array, adjust as needed

  return (
    <div className="bg-white">
      <div className="bg-pagePattern bg-center">
        <div className="flex mx-auto max-w-screen-lg text-center justify-center items-center mb-4 h-32  ">
          <span className="text-7xl text-textWhite font-medium">
            Zulal Store
          </span>
        </div>
      </div>

      <div className="flex mx-auto items-center justify-center max-w-2xl px-4 mb-8 py-8 sm:px-6 sm:py-8 lg:max-w-7xl lg:px-8">
        <div></div>
        <div className="mb-8 grid grid-cols-1 gap-y-12 sm:grid-cols-2 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
          {products.map((product) => (
            <ProductCard1 key={product.id} product={product} />
          ))}
        </div>
      </div>
    </div>
  );
};
